import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { appointments } from '../data/siteData';

const { FiChevronLeft, FiChevronRight, FiMoreHorizontal, FiCheck } = FiIcons;

const getUpcomingWeekdays = () => {
  const dates = [];
  const currentDate = new Date();

  for (let offset = 0; offset <= 14 && dates.length < 5; offset += 1) {
    const futureDate = new Date(currentDate);
    futureDate.setDate(currentDate.getDate() + offset);

    if (offset === 0 || (futureDate.getDay() !== 0 && futureDate.getDay() !== 6)) {
      dates.push(futureDate);
    }
  }

  return dates;
};

const formatAgendaDate = (date) => date.toLocaleDateString('en-US', {
  weekday: 'long',
  month: 'long',
  day: 'numeric',
});

const formatCalendarDay = (date) => `${date.toLocaleDateString('en-US', {
  weekday: 'narrow',
})} ${date.getDate()}`;

function BookingPreview() {
  const upcomingWeekdays = getUpcomingWeekdays();
  const agendaDate = upcomingWeekdays[0];

  return (
    <motion.div
      className="booking-preview"
      initial={{ opacity: 0, y: 30, rotate: 1 }}
      animate={{ opacity: 1, y: 0, rotate: 0 }}
      transition={{ duration: 0.8, delay: 0.15 }}
    >
      <div className="preview-top">
        <div><span>Today’s agenda</span><strong>{formatAgendaDate(agendaDate)}</strong></div>
        <button type="button" aria-label="More options"><SafeIcon icon={FiMoreHorizontal} /></button>
      </div>
      <div className="calendar-strip">
        <button type="button" aria-label="Previous week"><SafeIcon icon={FiChevronLeft} /></button>
        {upcomingWeekdays.map((date, index) => (
          <span className={index === 0 ? 'selected' : ''} key={date.toISOString()}>{formatCalendarDay(date)}</span>
        ))}
        <button type="button" aria-label="Next week"><SafeIcon icon={FiChevronRight} /></button>
      </div>
      <div className="appointment-list">
        {appointments.map((item) => (
          <div className="appointment" key={item.time}>
            <time>{item.time}</time>
            <i className={item.color} />
            <div><strong>{item.name}</strong><span>{item.client}</span></div>
            <span className="check"><SafeIcon icon={FiCheck} /></span>
          </div>
        ))}
      </div>
      <div className="capacity">
        <div><span>Weekly capacity</span><strong>18 of 24 slots</strong></div>
        <div className="capacity-track"><span /></div>
      </div>
    </motion.div>
  );
}

export default BookingPreview;